export function roundOfMaxsize(count) {
    const total = count
    let roundedMaxSize;
    
    const stepCount = 5;
    if(total <=1000){
      roundedMaxSize = Math.ceil(total / 10) * 10;

    }else if (total <=10000){
     roundedMaxSize = Math.ceil(total / 100) * 100;

    }else if (total <=100000){
      roundedMaxSize = Math.ceil(total / 1000) * 1000;

     }else{
      roundedMaxSize = Math.ceil(total / 10000) * 10000;
    }
    // Calculate the step size
    const stepSize = roundedMaxSize / stepCount;

    return {roundedMaxSize,stepSize}
}


